/**
 * Team-alert notification tone for missed calls/chats.
 *
 * Synthesizes a short urgent triple-beep using the shared Web Audio primitives
 * in audioTone (same AudioContext as DTMF and chat chimes). No audio assets.
 */

import { getAudioContext, playToneBurst } from '@/utils/audioTone';

/** Three quick high beeps, spaced 150ms apart. */
const ALERT_NOTES = [
  { frequency: 1568, startOffsetSeconds: 0, durationSeconds: 0.12 },
  { frequency: 1568, startOffsetSeconds: 0.15, durationSeconds: 0.12 },
  { frequency: 1568, startOffsetSeconds: 0.3, durationSeconds: 0.12 },
];

const TONE_GAIN = 0.12;

/** Plays the missed-contact alert tone. Best-effort: silent if audio is unavailable. */
export function playAlertTone(): void {
  try {
    const ctx = getAudioContext();
    if (!ctx || ctx.state === 'closed') return;
    const startAt = ctx.currentTime;
    for (const note of ALERT_NOTES) {
      playToneBurst(ctx, {
        frequency: note.frequency,
        startTime: startAt + note.startOffsetSeconds,
        durationSeconds: note.durationSeconds,
        gain: TONE_GAIN,
      });
    }
  } catch {
    // Audio unavailable (headless browser, autoplay policy) — alert still shows.
  }
}
